import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center text-center py-8 px-4 bg-[url('https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1920')] bg-center bg-cover bg-no-repeat" data-id="element-122">
      <div className="absolute inset-0 bg-gradient-to-b from-black/85 to-black/70 z-0 pointer-events-none" data-id="element-123"></div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-orange via-[#ff8c00] to-brand-orange z-10" data-id="element-124"></div>

      <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col items-center" data-id="element-125">
        <h1 className="font-oswald text-[24px] md:text-5xl lg:text-6xl font-bold max-w-[900px] mb-3 md:mb-5 drop-shadow-[0_2px_20px_rgba(0,0,0,0.8)] leading-[1.15]" data-id="element-126">
          ¿Qué haría tu familia si mañana
          <br data-id="element-127" />
          <span className="text-brand-orange" data-id="element-128">
            la ciudad se apagara para siempre?
          </span>
        </h1>

        <p className="text-[14px] md:text-lg lg:text-xl text-[#cccccc] max-w-[650px] mb-6 md:mb-8 leading-relaxed" data-id="element-129">
          El sistema de agua, comida y energía que te han enseñado a depender
          puede colapsar en menos de 24 horas. Este protocolo te convierte en el
          ancla de seguridad de tu familia{' '}
          <strong className="text-white font-semibold" data-id="element-130">
            antes de que sea tarde.
          </strong>
        </p>

        <div className="bg-gradient-to-br from-[#1a1a1a] to-[#2d2d2d] border border-brand-orange rounded-2xl p-4 md:p-7 max-w-[750px] w-full mx-auto shadow-[0_0_60px_rgba(255,87,51,0.3)] relative" data-id="element-131">
          <div className="absolute -top-[14px] left-1/2 -translate-x-1/2 bg-brand-orange text-white py-1 px-5 rounded-full text-[11px] md:text-xs font-bold tracking-wide whitespace-nowrap" data-id="element-132">
            🔥 OFERTA DE LANZAMIENTO
          </div>

          <div className="mb-4 rounded-xl overflow-hidden shadow-2xl border border-white/10" data-id="element-133">
            <img src="https://cdn.magicpatterns.com/uploads/nERJyoStXzYqt33qnLAV6t/Gemini_Generated_Image_r94zblr94zblr94z.png" alt="El Protocolo Blackout Mockup" className="w-full h-auto object-cover" data-id="element-134" />
          </div>

          <div className="text-center mb-3" data-id="element-135">
            <p className="text-[13px] md:text-sm text-[#aaa]" data-id="element-136">
              Todo lo que necesitás para proteger a tu familia cuando la ciudad
              se apague.
            </p>
          </div>

          <CTAButton href="#comprar-ahora" scrollTo="comprar-ahora" showPaymentMethods data-id="element-137">
            🛡️ QUIERO PROTEGER A MI FAMILIA AHORA
          </CTAButton>

          <p className="text-[12px] md:text-[13px] text-[#888] text-center mt-2" data-id="element-138">
            🔒 Pago 100% seguro · Acceso instantáneo · Garantía incluida
          </p>
        </div>
      </div>
    </section>;
}